<template>
	<v-simple-table>
		<template v-slot:default>
			<tbody>
				<tr
					v-for="(day, index) in days"
					:key="index"
					style="min-height: 141px !important"
				>
					<td width="300">
						<v-switch
							v-model="item[day.value].active"
							:label="day.text"
							class="text-capitalize"
							inset
						></v-switch>
					</td>

					<td class="py-5">
						<template v-if="item[day.value].active == true">
							<v-layout row wrap>
								<template
									v-for="(time, index) in item[day.value]
										.times"
								>
									<v-flex
										xs12
										md5
										:key="`${day.text}_start_${index}`"
									>
										<v-autocomplete
											:items="times"
											v-model="time.time_start"
											:label="$t('Start Time')"
											outlined
										></v-autocomplete>
									</v-flex>
									<v-flex
										class="text-center"
										xs12
										md1
										:key="`${day.text}_sign_${index}`"
									>
										<v-icon class="mt-3"
											>mdi-arrow-right</v-icon
										>
									</v-flex>
									<v-flex
										xs12
										md5
										:key="`${day.text}_end_${index}`"
									>
										<v-autocomplete
											:items="times"
											v-model="time.time_end"
											:label="$t('End Time')"
											outlined
										></v-autocomplete>
									</v-flex>
									<v-flex
										xs12
										md1
										:key="`${day.text}_delete_${index}`"
										class="text-right"
									>
										<v-btn
											color="red"
											sm
											icon
											fab
											@click="
												item[day.value].times.splice(
													index,
													1
												)
											"
										>
											<v-icon> mdi-delete </v-icon>
										</v-btn>
									</v-flex>
								</template>
								<v-flex xs12>
									<v-btn
										color="secondary"
										sm
										text
										@click="
											item[day.value].times.push({
												time_start: '07:00:00',
												time_end: '17:00:00',
											})
										"
									>
										<v-icon left> mdi-plus </v-icon>
										{{ $t("Add Hour") }}
									</v-btn>
								</v-flex>
							</v-layout>
						</template>

						<template v-else>
							{{ $t("Closed for whole day.") }}
						</template>
					</td>
				</tr>
			</tbody>
		</template>
	</v-simple-table>
</template>

<script>
export default {
	name: "ScheduleComponent",

	props: ["value"],

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},

		days() {
			return [
				{
					value: "mon",
					text: this.$t("Monday"),
				},
				{
					value: "tue",
					text: this.$t("Tuesday"),
				},
				{
					value: "wed",
					text: this.$t("Wednesday"),
				},
				{
					value: "thu",
					text: this.$t("Thursday"),
				},
				{
					value: "fri",
					text: this.$t("Friday"),
				},
				{
					value: "sat",
					text: this.$t("Saturday"),
				},
				{
					value: "sun",
					text: this.$t("Sunday"),
				},
			];
		},
		times() {
			var x = 15; //minutes interval
			var times = []; // time array
			var tt = 0; // start time
			var ap = ["AM", "PM"]; // AM-PM

			//loop to increment the time and push results in array
			for (var i = 0; tt < 24 * 60; i++) {
				var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
				var mm = tt % 60; // getting minutes of the hour in 0-55 format
				times[i] = {
					value: `${("0" + hh).slice(-2)}:${("0" + mm).slice(-2)}:00`,
					text:
						("0" + (hh % 12)).slice(-2) +
						":" +
						("0" + mm).slice(-2) +
						ap[Math.floor(hh / 12)],
				};
				tt = tt + x;
			}

			return times;
		},
	},
};
</script>